'use client';

/**
 * Cart Widget - Full Canvas view for RFQ Cart
 *
 * @component_role Cart Canvas Widget
 * @business_rule Uses CartCanvasView for spacious grid layout in Canvas.
 *   Products displayed as cards in responsive grid, RFQ form below.
 * @user_outcome Full-width cart view for reviewing large orders before submission.
 *
 * @layer presentation
 * @arch_component_type widget
 * @arch_domain procurement
 */

import { CartCanvasView } from '@/components/cart/cart-canvas-view';

interface CartWidgetProps {
  entityId: string;
  title: string;
}

export function CartWidget({ entityId, title }: CartWidgetProps) {
  return <CartCanvasView />;
}
